import React, { useEffect, useState, useContext } from 'react';
import {
  Container,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Button,
  TableBody,
  IconButton,
  TextField,
  Stack,
  Tooltip,
  FormControl
} from '@mui/material';
import { Visibility, Edit, Delete, Folder, Add, ArrowUpward, ArrowDownward } from '@mui/icons-material';
import contribuenteApi from '../../api/contribuenteApi';
import { useNavigate } from 'react-router-dom';
import ConfirmDeleteModal from '../../components/ConfirmDeleteModal';
import ProtectedAction from '../../components/ProtectedAction';
import BackButtonDesktop from '../../components/BackButtonDesktop';
import { AuthContext } from '../../auth/AuthContext';
import { formatDate } from '../../utils/dateFormatter';

export default function ContribuentiListPageDesktop() {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const isAdmin = user?.role === 'ADMIN';
  const isStudio = user?.role === 'STUDIO';
  console.log("user",user);
  const [contribuenti, setContribuenti] = useState([]);
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [selectedId, setSelectedId] = useState(null);
  const [sortField, setSortField] = useState('cognome');
  const [sortDirection, setSortDirection] = useState('ASC'); // ASC o DESC
  const [filters, setFilters] = useState({});
  const [loading, setLoading] = useState(false);

  const pageSize = 10;

  useEffect(() => {
    fetchContribuenti(0);
  }, [user]);

  const fetchContribuenti = (page) => {
    if (!user) return;
      setLoading(true);
      const params = {
        page,
        size: pageSize,
        sort: `${sortField},${sortDirection}`,
        ...filters
      };
    console.log("params",params);
    const call =
      user.role === 'ADMIN'
        ? contribuenteApi.list(params)
        : contribuenteApi.listbystudio(user.studioId, params);

    call
      .then(r => {
        setContribuenti(r.data.content || []);
        setTotalPages(r.data.totalPages || 0);
        setPage(r.data.number || 0);
      })
      .catch(err => console.error(err));
      setLoading(false);
  };

  const openDeleteDialog = (id) => {
    setSelectedId(id);
    setOpenDeleteModal(true);
  };

  const closeDeleteDialog = () => {
    setSelectedId(null);
    setOpenDeleteModal(false);
  };

  const confirmDelete = async () => {
    try {
      await contribuenteApi.delete(selectedId);
      fetchContribuenti(page);
    } catch (err) {
      console.error(err);
    }
    closeDeleteDialog();
  };

  const handleSort = (field) => {
    if (sortField === field) {
      setSortDirection(sortDirection === 'ASC' ? 'DESC' : 'ASC');
    } else {
      setSortField(field);
      setSortDirection('ASC');
    }
    fetchContribuenti(0);
  };

  const renderSortIcon = (field) => {
    if (sortField !== field) return null;
    return sortDirection === 'ASC' ? <ArrowUpward fontSize="small" /> : <ArrowDownward fontSize="small" />;
  };

  // === Funzione per esportare tutti i contribuenti in CSV ===
const exportToCSV = async () => {
  try {
    // Recupera tutti i record (pageSize molto grande)
    const res = await (user.role === 'ADMIN'
      ? contribuenteApi.list({ page: 0, size: totalPages * pageSize || 1000 })
      : contribuenteApi.listbystudio(user.studioId, { page: 0, size: totalPages * pageSize || 1000 })
    );

    const allContribuenti = res.data.content || [];

    // Nuove intestazioni
    const headers = ["Nome", "Cognome", "Codice Fiscale", "Partita IVA", "Email", "Telefono","Indirizzo","Regime Fiscale", "ID"];

    // Mappa tutte le colonne
    const rows = allContribuenti.map(c => [
      c.nome || '',
      c.cognome || '',
      c.codiceFiscale || '',
      c.partitaIVA || '',
      c.email || '',
      c.telefono || '',
      c.indirizzo || '',
      c.regimeFiscale || '',
      c.id
    ]);

      let csvContent = "data:text/csv;charset=utf-8,"
        + [headers.join(";"), ...rows.map(r => r.join(";"))].join("\n");
    const encodedUri = encodeURI(csvContent);
    const link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "contribuenti.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (err) {
    console.error('Errore esportazione CSV:', err);
  }
};

  return (
    <Container>
      {loading && (
        <Box
          sx={{
            position: 'fixed',
            inset: 0,
            bgcolor: 'rgba(255,255,255,0.7)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1300,
          }}
        >
          <CircularProgress size={48}/>
        </Box>
      )}
    <BackButtonDesktop />
    <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
      <Typography variant="h4" sx={{ mb: 2 }}>Contribuenti</Typography>
    </Stack>
      {/* Filtri */}
       <Stack direction="row" spacing={2} sx={{ mb: 2, flexWrap: 'wrap' }}>
        <TextField
          label="Cognome"
          name="cognome"
          size="small"
          value={filters.cognome || ''}
          onChange={(e) => setFilters(prev => ({ ...prev, cognome: e.target.value }))}
        />

        <TextField
          label="Partita IVA"
          name="partitaIva"
          size="small"
          value={filters.partitaIva || ''}
          onChange={(e) => setFilters(prev => ({ ...prev, partitaIva: e.target.value }))}
        />

        <Button variant="contained" onClick={() => fetchContribuenti(0)}>Cerca</Button>
        <Button variant="outlined" onClick={() => { setFilters({}); fetchContribuenti(0); }}>
          Resetta Filtri
        </Button>
       </Stack>


      {isStudio && (
      <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
       <ProtectedAction user={user} contractState={user.statoContratto}>
      <Button
        variant="contained"
        sx={{ my: 1 }}
        onClick={() => navigate(`/contribuenti/createfromuser/${user.userId}`)}
      >
        Aggiungi Contribuente
      </Button></ProtectedAction>
    <Button variant="outlined" onClick={exportToCSV}>
      Esporta CSV
    </Button>
      </Stack>
      )}

    {isAdmin && (
    <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
      <Button variant="contained" onClick={() => navigate('/contribuenti/create')}>
        Inserisci Contribuente
      </Button>
      <Button variant="outlined" onClick={exportToCSV}>
        Esporta CSV
      </Button>
    </Stack>
    )}
      {/* PAGINAZIONE */}
      <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
        {Array.from({ length: totalPages }, (_, i) => (
          <Button
            key={i}
            variant={i === page ? "contained" : "outlined"}
            onClick={() => fetchContribuenti(i)}
          >
            {i + 1}
          </Button>
        ))}
      </Stack>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Nome</TableCell>
            <TableCell onClick={() => handleSort('cognome')}
                         style={{ cursor: 'pointer' }}>
              Cognome {renderSortIcon('cognome')}
              </TableCell>
              <TableCell onClick={() => handleSort('partitaIVA')}
                           style={{ cursor: 'pointer' }}>
                 Partita IVA  {renderSortIcon('partitaIVA')}
            </TableCell>
            <TableCell>Codice fiscale</TableCell>
            <TableCell>Email</TableCell>
            <TableCell>Telefono</TableCell>
            <TableCell>Regime Fiscale</TableCell>
            <TableCell>Azioni</TableCell>
          </TableRow>
        </TableHead>

        <TableBody>
          {contribuenti.map(c => (
            <TableRow key={c.id}>
              <TableCell>{c.nome}</TableCell>
              <TableCell>{c.cognome}</TableCell>
              <TableCell>{c.partitaIVA}</TableCell>
              <TableCell>{c.codiceFiscale}</TableCell>
              <TableCell>{c.email}</TableCell>
              <TableCell>{c.telefono}</TableCell>
              <TableCell>{c.regimeFiscale}</TableCell>
              <TableCell>
                <Stack direction="row">
                <Tooltip title="dettaglio">
                  <IconButton color="primary" size="small" onClick={() => navigate(`/contribuenti/${c.id}`)}>
                    <Visibility />
                  </IconButton>
                  </Tooltip>
                  <Tooltip title="fascicolo">
                 <IconButton color="primary" size="small" onClick={() => navigate(`/contribuente/${c.id}/fascicolo`)}>
                            <Folder />
                   </IconButton>
                   </Tooltip>
                   <Tooltip title="modifica">
                  <IconButton color="secondary" size="small" onClick={() => navigate(`/contribuenti/edit/${c.id}`)}>
                    <Edit />
                  </IconButton>
                  </Tooltip>
                    <Tooltip title="elimina">
                  <IconButton color="error" size="small" onClick={() => openDeleteDialog(c.id)}>
                    <Delete />
                  </IconButton>
                  </Tooltip>
                </Stack>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {/* PAGINAZIONE */}
      <Stack direction="row" spacing={1} sx={{ mt: 2 }}>
        {Array.from({ length: totalPages }, (_, i) => (
          <Button
            key={i}
            variant={i === page ? "contained" : "outlined"}
            onClick={() => fetchContribuenti(i)}
          >
            {i + 1}
          </Button>
        ))}
      </Stack>

      <ConfirmDeleteModal
        open={openDeleteModal}
        onCancel={closeDeleteDialog}
        onConfirm={confirmDelete}
        message="Sei sicuro di voler eliminare questo contribuente?"
      />
    </Container>
  );
}